<template>
  <b-dropdown
    variant="outline-default"
    menu-class="menu-shadow scrollable text-medium"
    toggle-class="rounded-pill flex-center justify-content-between"
    :disabled="disabled"
  >
    <template slot="button-content">
      <div class="text-truncate button-content" :title="selected.name" v-no-capture>
        {{ selected.name }}
      </div>
    </template>
    <org-selector-dropdown-item :team="rootTeam" @select="onSelect" />
  </b-dropdown>
</template>

<script>
import OrgSelectorDropdownItem from '@/components/goal/OrgSelectorDropdownItem'
import TeamMixin from '@/mixins/TeamMixin'
import { BDropdown } from 'bootstrap-vue'

export default {
  name: 'OrgSelectorDropdown',
  props: {
    orgId: Number,
    selected: {
      type: Object,
      default: () => ({})
    },
    disabled: Boolean
  },
  mixins: [TeamMixin],
  components: {
    BDropdown,
    OrgSelectorDropdownItem
  },
  computed: {
    rootTeam() {
      return this.getTeamTree('orgLikeOnly').find(x => x.organizationId === this.orgId)
    }
  },
  methods: {
    onSelect(team) {
      this.$emit('change', team)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

$dropdown-width: 165px;

/deep/ .button-content {
  width: $dropdown-width;
}

/deep/ button {
  text-align: left;
  border-color: $borderPrimary;
}
</style>
